


















































import {mapActions, mapGetters} from 'vuex';
import Vue from 'vue';
import {Advert} from '#/Advert';
import {TranslateResult} from 'vue-i18n';
import {CategoryAPI} from '#/Category';

interface ComponentData {
  scrollHeight: number | null;
  openPanels: number[];
  onLoad: boolean;
  afterCreation: boolean;
}

export default Vue.extend({
  name: 'AdvertList',

  components: {
    advert: () => import('@/components/advert/ListTemplate.vue'),
  },

  data: (): ComponentData => ({
    scrollHeight: null,
    openPanels: [0, 1, 2],
    onLoad: true,
    afterCreation: false, // évite d'afficher un reliquat annonce d'une page à l'autre
  }),

  computed: {
    ...mapGetters([
      'typeFilter',
      'urlNextPage',
      'pageNumber',
      'adverts',
      'username',
      'categoryFromId',
      'queryFromCategoryId',
    ]),
    /**
     *
     * @returns {boolean}
     */
    isPersonalList(): boolean {
      return this.$route.name === 'PersonalAdvertList';
    },
    isFavoriteList(): boolean {
      return this.$route.name === 'FavoriteList';
    },
    isDefaultList(): boolean {
      return this.$route.name === 'DefaultList';
    },
    drafts(): Advert[] {
      return this.onLoad
          ? []
          : this.adverts.filter((ad: Advert) => !ad.isPublished && ad.archivedAt === null);
    },
    selfPublishedAdverts(): Advert[] {
      return this.onLoad && this.isPersonalList
          ? []
          : this.adverts.filter((ad: Advert) => ad.isPublished);
    },
    archivedAdverts(): Advert[] {
      return this.onLoad
          ? []
          : this.adverts.filter((ad: Advert) => !ad.isPublished && ad.archivedAt !== null);
    },
    publishedAdverts(): Advert[] {
      return this.afterCreation ? this.adverts : [];
    },
    extraFilters(): { author__username?: string, is_published?: boolean, is_favorite?: boolean } {
      return this.isDefaultList
          ? {}
          : {
            ...this.isPersonalList ? {author__username: this.username} : {is_published: true},
            ...this.isFavoriteList ? {is_favorite: true} : {},
          };
    },
    middlePage(): number {
      const divisor = this.pageNumber * 2;
      return this.scrollHeight ? Math.round(this.scrollHeight * (divisor - 1) / divisor) : 0;
    },
    title(): TranslateResult {
      return this.$t(`advert.list.title.${this.$route.name}`);
    },
    categoryFilter(): CategoryAPI {
      return Object.keys(this.$route.query)
                   .includes('category') &&
          this.categoryFromId(parseInt(this.$route.query.category as string));
    },
    canPostFirst(): boolean {
      return (this.categoryFilter
          // @ts-ignore
          && this.categoryFilter.isSelectable
          && (!this.onLoad && !this.typeFilter));
    },
  },

  watch: {
    $route: {
      deep: true,
      handler: function () {
        this.onLoad = true;
        this.loadAdverts({filters: this.getQueryFromRoute(), fromDefault: this.isDefaultList})
            .then(() => {
              this.updatePageTitle(this.title);
              this.onLoad = false;
            });
      },
    },
  },

  created() {
    const {archive} = this.$route.query;
    if (archive) {
      this.openPanels = [2];
    }
    this.loadCategories()
        .then(() => {
          this.loadAdverts({
            filters: this.getQueryFromRoute(),
            fromDefault: this.isDefaultList,
          })
              .then(() => {
                this.onLoad = false;
                this.afterCreation = true;
              });
        });
    this.updatePageTitle(this.title);
  },
  methods: {
    ...mapActions([
      'loadAdverts',
      'loadNextPage',
      'loadCategories',
      'updatePageTitle',
      'selectTypeFilter',
    ]),
    onListScroll(event: UIEvent) {
      if (this.urlNextPage) {
        // @ts-ignore
        const {scrollTop, clientHeight, scrollHeight} = event.target as EventTarget;
        if (scrollHeight !== this.scrollHeight) this.scrollHeight = scrollHeight;
        if ((scrollTop + clientHeight > this.middlePage) && !this.onLoad) {
          this.onLoad = true;
          this.loadNextPage()
              .then(() => {
                this.onLoad = false;
              });
        }
      }
    },
    getQueryFromRoute() {
      // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
      const {category: categoryId, q, archive, ...cleanedQuery} = this.$route.query;
      return {
        ...this.extraFilters,
        ...cleanedQuery,
        ...categoryId ? this.queryFromCategoryId(parseInt(`${categoryId}`)) : {},
      };
    },
    onCreateAdvertWithCategory() {
      this.$router.push({
        name: 'AdvertCreation',
        query: {category: `${this.categoryFilter.id}`},
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.selectTypeFilter(to.query.types);
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch('selectTypeFilter', to.query.types);
      next();
    });
  },
});
